module.exports = __webpack_public_path__ + "img/folder-3-line.bc8202b5.svg";